import React, { useContext } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import NotificationForMyselfOrLeadsSelect from 'components/NotificationForMyselfOrLeadsSelect';
import { Button } from 'ncoded-component-library';
import ArrowsexpandIcon from 'icons/Arrowsexpand.icon';
import {
  NOTIFICATIONS_ROUTE,
  PROFILE_PERSONAL_DETAILS_ROUTE,
} from 'data/global';
import ThreeDotsDropdown from 'components/ThreeDotsDropdown';
import NotificationGroupSelect from 'components/NotificationsDrawer/components/NotificationGroupSelect';
import NotificationUnreadToggle from 'components/NotificationsDrawer/components/NotificationUnreadToggle';
import NotificationsContext from 'providers/Notifications/Notifications.context';
import { getIsNotificationForLeads } from 'utils';
import { useNavigate } from 'react-router-dom';

import './NotificationsHeader.styles.scss';

type NotificationsHeaderProps = {
  className?: string;
  showExpand?: boolean;
  onClose?: () => void;
};

const NotificationsHeader: React.FC<NotificationsHeaderProps> = (props) => {
  const { className, showExpand = false, onClose } = props;

  const { notificationBy, readAllNotifications } =
    useContext(NotificationsContext);

  const isForLeads = getIsNotificationForLeads(notificationBy);

  const classes = classNames('notifications-header', className);

  const { t } = useTranslation();

  const navigate = useNavigate();

  return (
    <div className={classes}>
      <NotificationForMyselfOrLeadsSelect />

      <div>
        <div className="title">
          <p>{t('notifications')}</p>

          {showExpand && (
            <Button
              aria-label="Show all notifications."
              variant="icon"
              icon={ArrowsexpandIcon}
              className="expand"
              onClick={() => {
                onClose?.();
                navigate(NOTIFICATIONS_ROUTE);
              }}
            />
          )}
        </div>

        {!isForLeads && <NotificationUnreadToggle />}
      </div>

      {!isForLeads && (
        <div>
          <NotificationGroupSelect />
          <ThreeDotsDropdown
            options={[
              {
                label: t('markAllAsRead'),
                onClick: readAllNotifications,
              },
              {
                label: t('notificationSettings'),
                onClick: () => {
                  onClose?.();
                  navigate(PROFILE_PERSONAL_DETAILS_ROUTE);
                },
              },
            ]}
          />
        </div>
      )}
    </div>
  );
};

export default NotificationsHeader;
